import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  id: yup.number().required(),
});

const responseSchema = yup.object({
  id: yup.number().required(),
  title: yup.string().required(),
  isPublished: yup.boolean().required(),
  questions: yup
    .array()
    .of(
      yup.object({
        id: yup.number().required(),
        name: yup.string().nullable().default(""),
        boxtype: yup.string().required(),
        description: yup.boolean().required(),
        descriptionText: yup.string().nullable(),
        displayOrder: yup.number().required(),
        options: yup.array().of(yup.string()).required(),
        required: yup.boolean().required(),
        why_choose: yup.boolean().required(),
      }),
    )
    .required(),
});

const composeResponse = (res) => {
  const data = res.data.data || {};
  return {
    id: data.sid,
    title: data.title,
    isPublished: Boolean(data.is_published),
    questions: (data.data || []).map((q) => ({
      ...q,
      description: Boolean(q.description),
      required: Boolean(q.required),
      why_choose: Boolean(q.why_choose),
    })),
  };
};

export const useSurveyQuery = ({ payload, options = {} }) => {
  return useQuery({
    queryKey: [QUERY_KEYS.surveys.one, payload.id],
    queryFn: async () => {
      const req = requestSchema.validateSync(payload, {
        strict: true,
      });
      const res = await http.get(HTTP_ENDPOINTS.surveys.get(req.id));
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    ...options,
  });
};
